import { ReactComponent as CalendarIcon } from "../../../../assets/icons/Sample Submission Redesign/calendar-todo-line.svg";
import { ReactComponent as CorrectiveActionIcon } from "../../../../assets/images/sample-submission/CorrectiveActionIcon.svg";
import { ReactComponent as SampleSubmissionIcon } from "../../../../assets/images/sample-submission/SampleSubmissionIcon.svg";
import { ReactComponent as SwabIcon } from "../../../../assets/images/sample-submission/SwabIcon.svg";

export const SUBMISSION_CATEGORY_MAP = {
  regular: { label: "Sample Submission", icon: SampleSubmissionIcon },
  retest: { label: "Re-Test", icon: SampleSubmissionIcon },
  randomizer: { label: "Randomizer", icon: SwabIcon },
  scheduling_calendar: { label: "Environment Calendar", icon: CalendarIcon },
  scheduling_report: { label: "Environment Calendar", icon: CalendarIcon },
  corrective_action: { label: "Corrective Action", icon: CorrectiveActionIcon },
  swabathon: { label: "Swabathon", icon: SwabIcon },
};

/**
 * Display config for a submission's `submission_category`
 * @param {Object} submission submission from the sample submission API
 * @returns {Object|null} entry from SUBMISSION_CATEGORY_MAP, null when the category is missing or unknown
 */
export const getSubmissionCategoryConfig = (submission) => {
  const category = String(submission?.submission_category ?? "").trim().toLowerCase();
  return SUBMISSION_CATEGORY_MAP[category] || null;
};
